var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wallet-settings" } },
    [
      _vm.addBalanceModal
        ? _c("WalletAddBalance", {
            attrs: { "is-admin": _vm.isAdmin },
            on: {
              "add-balance": _vm.addBalanceWhatsapp,
              close: function ($event) {
                _vm.addBalanceModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.creditCardNeededModal
        ? _c("CreditCardNeeded", {
            on: {
              close: function ($event) {
                _vm.creditCardNeededModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAutoRebalancePromo
        ? _c("AutoRebalancePromoModal", {
            on: {
              activate: _vm.handleAutoRebalancePromoActivate,
              close: _vm.handleAutoRebalancePromoClose,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wallet" }, [
        _c("div", { staticClass: "whatsapp-wallet" }, [
          _c("div", { staticClass: "logo" }, [_c("WalletSVG")], 1),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "wallet-info" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("billing.availableBalance"))),
              ]),
              _vm._v(" "),
              _vm.wallet.whatsapp
                ? _c("div", { staticClass: "balance" }, [
                    _vm._v(
                      _vm._s(_vm.formatPrice(_vm.wallet.whatsapp.amount)) + "TL"
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wallet-add",
                on: { click: _vm.openAddWhatsappBalanceModal },
              },
              [_vm._v(_vm._s(_vm.$t("billing.addBalance")))]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wallet-content" }, [
        _c("div", { staticClass: "wallet-tabs" }, [
          _c("div", { staticClass: "tab-buttons" }, [
            _c(
              "div",
              {
                staticClass: "tab-button",
                class: { active: _vm.activeMainTab === "transactions" },
                on: {
                  click: function ($event) {
                    return _vm.setActiveMainTab("transactions")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("receipt_long"),
                ]),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("billing.walletTransactions")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-button",
                class: { active: _vm.activeMainTab === "auto-rebalance" },
                on: {
                  click: function ($event) {
                    return _vm.setActiveMainTab("auto-rebalance")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("autorenew"),
                ]),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("billing.autoReload")) +
                    "\n                "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.activeMainTab === "transactions"
          ? _c(
              "div",
              {
                key: _vm.$i18n.locale,
                staticClass: "tab-content transactions-content",
              },
              [
                _c("div", { staticClass: "wallet-logs" }, [
                  _c("div", { staticClass: "product-tabs" }, [
                    _c(
                      "div",
                      { staticClass: "tab-buttons" },
                      _vm._l(_vm.productTabs, function (tab) {
                        return _c(
                          "div",
                          {
                            key: tab.key,
                            staticClass: "tab-button",
                            class: { active: _vm.activeTab === tab.key },
                            on: {
                              click: function ($event) {
                                return _vm.setActiveTab(tab.key)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v(_vm._s(tab.icon)),
                            ]),
                            _vm._v(
                              "\n                    " +
                                _vm._s(tab.label) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.currentTabTypes.length > 0
                      ? _c("div", { staticClass: "type-chips" }, [
                          _c("div", { staticClass: "chips-label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("billing.transactionTypes")) +
                                "\n                    "
                            ),
                            _c("span", { staticClass: "chips-hint" }, [
                              _vm._v(
                                _vm._s(_vm.$t("billing.transactionTypesHint"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chips-container" },
                            _vm._l(_vm.currentTabTypes, function (typeKey) {
                              return _c(
                                "div",
                                {
                                  key: typeKey,
                                  staticClass: "type-chip",
                                  class: {
                                    active: _vm.selectedTypes.includes(typeKey),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleType(typeKey, $event)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.types[typeKey]) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("billing.walletLogs")) +
                        "\n            "
                    ),
                    _c(
                      "div",
                      { staticClass: "pagination" },
                      [
                        _c(
                          "div",
                          [
                            _c("a-date-picker", {
                              attrs: {
                                placeholder: _vm.$t("message.startDate"),
                                "show-time": "",
                                format: "YYYY-MM-DD HH:mm:ss",
                              },
                              model: {
                                value: _vm.filters.startDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "startDate", $$v)
                                },
                                expression: "filters.startDate",
                              },
                            }),
                            _vm._v(" "),
                            _c("a-date-picker", {
                              attrs: {
                                placeholder: _vm.$t("message.endDate"),
                                "show-time": "",
                                format: "YYYY-MM-DD HH:mm:ss",
                              },
                              model: {
                                value: _vm.filters.endDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "endDate", $$v)
                                },
                                expression: "filters.endDate",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.activeTab === "whatsapp-business-api"
                          ? _c(
                              "a-select",
                              {
                                staticClass: "filters-type",
                                model: {
                                  value: _vm.filters.channelId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "channelId", $$v)
                                  },
                                  expression: "filters.channelId",
                                },
                              },
                              [
                                _vm._l(_vm.channels, function (channel) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: channel._id,
                                      attrs: { value: channel._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(channel.name) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { selected: true, value: "" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.selectChannel")) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "pagination-controls" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.filters.perPage * (_vm.filters.page - 1) +
                                    1
                                ) +
                                " -\n                        " +
                                _vm._s(
                                  Math.min(
                                    _vm.filters.perPage * _vm.filters.page,
                                    _vm.totalActivity
                                  )
                                ) +
                                " / " +
                                _vm._s(_vm.totalActivity) +
                                "\n                        " +
                                _vm._s(_vm.$t("message.records") || "kayıt") +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "page-controls" },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "pagination-button",
                                  attrs: { disabled: _vm.filters.page <= 1 },
                                  on: { click: _vm.backwardPage },
                                },
                                [
                                  _c("div", { staticClass: "material-icons" }, [
                                    _vm._v("arrow_back_ios"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("a-input-number", {
                                staticClass: "page-input",
                                attrs: { min: 1, max: _vm.totalPages },
                                on: {
                                  pressEnter: _vm.jumpToPage,
                                  blur: _vm.jumpToPage,
                                },
                                model: {
                                  value: _vm.currentPageInput,
                                  callback: function ($$v) {
                                    _vm.currentPageInput = $$v
                                  },
                                  expression: "currentPageInput",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "page-separator" }, [
                                _vm._v("/ " + _vm._s(_vm.totalPages)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "pagination-button",
                                  attrs: {
                                    disabled:
                                      _vm.filters.page >= _vm.totalPages,
                                  },
                                  on: { click: _vm.forwardPage },
                                },
                                [
                                  _c("div", { staticClass: "material-icons" }, [
                                    _vm._v("arrow_forward_ios"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "logs" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.activities,
                          pagination: false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "createdAt",
                              fn: function (record) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [_vm._v(_vm._s(_vm.formatDate(record)))]
                                )
                              },
                            },
                            {
                              key: "type",
                              fn: function (record, item) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.formatType(record, item)) +
                                        "\n                    "
                                    ),
                                    item.type === "ai-usage"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                        (" +
                                              _vm._s(
                                                _vm.getAIUsageResource(item)
                                              ) +
                                              ")\n                    "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              },
                            },
                            {
                              key: "phoneNumber",
                              fn: function (record, item) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.getPhoneNumber(item)) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              },
                            },
                            {
                              key: "country",
                              fn: function (record, item) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            item,
                                            "payload.country",
                                            "-"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              },
                            },
                            {
                              key: "aiModel",
                              fn: function (record, item) {
                                return _c(
                                  "div",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ai-detail-model" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$_.get(
                                              item,
                                              "payload.model",
                                              "-"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              },
                            },
                            {
                              key: "aiProvider",
                              fn: function (record, item) {
                                return _c(
                                  "div",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    item.type === "ai-rag-rerank"
                                      ? _c("span", [_vm._v("Voyage AI")])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$_.get(
                                                item,
                                                "payload.openrouterGeneration.provider_name",
                                                _vm.$_.get(
                                                  item,
                                                  "payload.provider",
                                                  "-"
                                                )
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                )
                              },
                            },
                            {
                              key: "aiByok",
                              fn: function (record, item) {
                                return _c(
                                  "div",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _vm.$_.get(item, "payload.isByok") === true
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "blue" } },
                                          [_vm._v("Kendi Key")]
                                        )
                                      : _vm.$_.get(item, "payload.isByok") ===
                                        false
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "green" } },
                                          [_vm._v("Supsis")]
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ],
                                  1
                                )
                              },
                            },
                            {
                              key: "aiDetails",
                              fn: function (record, item) {
                                return _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      margin: "0",
                                      display: "flex",
                                      "flex-wrap": "wrap",
                                      gap: "4px",
                                    },
                                  },
                                  [
                                    item.type === "ai-rag-rerank"
                                      ? [
                                          _c(
                                            "a-tag",
                                            { attrs: { color: "purple" } },
                                            [_vm._v("ReRank")]
                                          ),
                                          _vm._v(" "),
                                          _vm.$_.get(
                                            item,
                                            "payload.inputTokens"
                                          ) > 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    color: "#666",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.formatTokenCount(
                                                          _vm.$_.get(
                                                            item,
                                                            "payload.inputTokens"
                                                          )
                                                        )
                                                      ) +
                                                      " token\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          _vm.$_.get(
                                            item,
                                            "payload.openrouterGeneration.num_search_results"
                                          ) > 0
                                            ? _c(
                                                "a-tag",
                                                { attrs: { color: "orange" } },
                                                [
                                                  _vm._v(
                                                    "\n                            Web " +
                                                      _vm._s(
                                                        _vm.$_.get(
                                                          item,
                                                          "payload.openrouterGeneration.num_search_results"
                                                        )
                                                      ) +
                                                      " sonuç\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_.get(
                                            item,
                                            "payload.openrouterGeneration.num_media_prompt"
                                          ) > 0
                                            ? _c(
                                                "a-tag",
                                                { attrs: { color: "purple" } },
                                                [
                                                  _vm._v(
                                                    "\n                            Medya " +
                                                      _vm._s(
                                                        _vm.$_.get(
                                                          item,
                                                          "payload.openrouterGeneration.num_media_prompt"
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_.get(
                                            item,
                                            "payload.openrouterGeneration.num_input_audio_prompt"
                                          ) > 0
                                            ? _c(
                                                "a-tag",
                                                { attrs: { color: "cyan" } },
                                                [
                                                  _vm._v(
                                                    "\n                            Ses " +
                                                      _vm._s(
                                                        _vm.$_.get(
                                                          item,
                                                          "payload.openrouterGeneration.num_input_audio_prompt"
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_.get(
                                            item,
                                            "payload.openrouterGeneration.router"
                                          )
                                            ? _c(
                                                "a-tag",
                                                {
                                                  attrs: { color: "geekblue" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.$_.get(
                                                          item,
                                                          "payload.openrouterGeneration.router"
                                                        ) === "openrouter/auto"
                                                          ? "Auto Router"
                                                          : _vm.$_.get(
                                                              item,
                                                              "payload.openrouterGeneration.router"
                                                            )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.$_.get(
                                            item,
                                            "payload.openrouterGeneration"
                                          )
                                            ? _c("span", [_vm._v("-")])
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                )
                              },
                            },
                            {
                              key: "before",
                              fn: function (record, item) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: { price: item.before.toFixed(4) },
                                    }),
                                  ],
                                  1
                                )
                              },
                            },
                            {
                              key: "after",
                              fn: function (record, item) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: { price: item.after.toFixed(4) },
                                    }),
                                  ],
                                  1
                                )
                              },
                            },
                            {
                              key: "amount",
                              fn: function (record, item) {
                                return _c(
                                  "p",
                                  { staticStyle: { margin: "0" } },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: { price: item.amount.toFixed(4) },
                                    }),
                                  ],
                                  1
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          370885030
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.activeMainTab === "auto-rebalance"
          ? _c("div", { staticClass: "tab-content auto-rebalance-content" }, [
              _c("div", { staticClass: "info-alerts" }, [
                _c("div", { staticClass: "alert-item compact warning" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("info"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "alert-content" }, [
                    _c("div", { staticClass: "alert-title" }, [
                      _vm._v(_vm._s(_vm.$t("billing.importantInfo"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "alert-points" }, [
                      _c("div", { staticClass: "point" }, [
                        _c("span", { staticClass: "bullet" }, [_vm._v("⚠️")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("billing.walletImportantPoint1"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "point" }, [
                        _c("span", { staticClass: "bullet" }, [_vm._v("⏰")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("billing.walletImportantPoint2"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "point" }, [
                        _c("span", { staticClass: "bullet" }, [_vm._v("🔔")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("billing.walletImportantPoint3Before")
                              )
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "link",
                                attrs: { to: "/settings/notifications" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("billing.notificationSettings"))
                                ),
                              ]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm.$t("billing.walletImportantPoint3After")
                              )
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "point" }, [
                        _c("span", { staticClass: "bullet" }, [_vm._v("📋")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("billing.walletImportantPoint4"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "point" }, [
                        _c("span", { staticClass: "bullet" }, [_vm._v("∞")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("billing.walletImportantPoint5"))
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "auto-rebalance-settings" }, [
                _c("div", { staticClass: "settings-header" }, [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("billing.autoBalanceReload"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("billing.autoBalanceReloadDesc"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "settings-content" }, [
                  _c("div", { staticClass: "setting-row" }, [
                    _c("div", { staticClass: "setting-label" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("billing.autoReloadToggle"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "setting-description" }, [
                        _vm._v(_vm._s(_vm.$t("billing.autoReloadToggleDesc"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "setting-control" },
                      [
                        _c("a-switch", {
                          on: { change: _vm.onAutoRebalanceEnabledChange },
                          model: {
                            value: _vm.autoRebalanceSettings.enabled,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.autoRebalanceSettings,
                                "enabled",
                                $$v
                              )
                            },
                            expression: "autoRebalanceSettings.enabled",
                          },
                        }),
                        _vm._v(" "),
                        _vm.autoRebalanceSettings.disabledDueToFailure
                          ? _c("span", { staticClass: "failure-warning" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("billing.disabledDueToFailure")
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.autoRebalanceSettings.enabled
                    ? _c("div", { staticClass: "setting-row" }, [
                        _c("div", { staticClass: "setting-label" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("billing.thresholdValue"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "setting-description" }, [
                            _vm._v(
                              _vm._s(_vm.$t("billing.thresholdValueDesc"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "setting-control" },
                          [
                            _c("a-input-number", {
                              staticStyle: { width: "150px" },
                              attrs: { min: 0, max: 5000, step: 1 },
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value: _vm.autoRebalanceSettings.threshold,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings,
                                    "threshold",
                                    $$v
                                  )
                                },
                                expression: "autoRebalanceSettings.threshold",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.autoRebalanceSettings.enabled
                    ? _c("div", { staticClass: "setting-row" }, [
                        _c("div", { staticClass: "setting-label" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("billing.reloadMode"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "setting-description" }, [
                            _vm._v(_vm._s(_vm.$t("billing.reloadModeDesc"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "setting-control mode-selection" },
                          [
                            _c(
                              "a-radio-group",
                              {
                                on: { change: _vm.onSettingsChange },
                                model: {
                                  value: _vm.autoRebalanceSettings.mode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.autoRebalanceSettings,
                                      "mode",
                                      $$v
                                    )
                                  },
                                  expression: "autoRebalanceSettings.mode",
                                },
                              },
                              [
                                _c("a-radio", { attrs: { value: "add" } }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("billing.addFixedAmount")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-radio",
                                  { attrs: { value: "fixedBalance" } },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("billing.fixBalance")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mode-description" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("info"),
                              ]),
                              _vm._v(" "),
                              _vm.autoRebalanceSettings.mode === "add"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("billing.modeAddDesc")) +
                                        "\n                                "
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t("billing.modeFixedDesc")
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.autoRebalanceSettings.enabled
                    ? _c("div", { staticClass: "setting-row" }, [
                        _c("div", { staticClass: "setting-label" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.autoRebalanceSettings.mode === "add"
                                  ? _vm.$t("billing.amountToAdd")
                                  : _vm.$t("billing.targetBalance")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "setting-description" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.autoRebalanceSettings.mode === "add"
                                    ? _vm.$t("billing.amountToAddDesc")
                                    : _vm.$t("billing.targetBalanceDesc")
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "setting-control" },
                          [
                            _c("a-input-number", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                min:
                                  _vm.autoRebalanceSettings.mode ===
                                  "fixedBalance"
                                    ? _vm.autoRebalanceSettings.threshold + 1
                                    : 1,
                                max: 10000,
                                step: 10,
                              },
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value: _vm.autoRebalanceSettings.upTo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings,
                                    "upTo",
                                    $$v
                                  )
                                },
                                expression: "autoRebalanceSettings.upTo",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.autoRebalanceSettings.enabled
                    ? _c("div", { staticClass: "setting-row" }, [
                        _c("div", { staticClass: "setting-label" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("billing.panelNotifications"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "setting-description" }, [
                            _vm._v(
                              _vm._s(_vm.$t("billing.panelNotificationsDesc"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "setting-control notification-checkboxes",
                          },
                          [
                            _c(
                              "a-checkbox",
                              {
                                on: { change: _vm.onSettingsChange },
                                model: {
                                  value:
                                    _vm.autoRebalanceSettings.settings
                                      .notifyOnRecharge,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.autoRebalanceSettings.settings,
                                      "notifyOnRecharge",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "autoRebalanceSettings.settings.notifyOnRecharge",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("billing.notifyOnRecharge")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-checkbox",
                              {
                                on: { change: _vm.onSettingsChange },
                                model: {
                                  value:
                                    _vm.autoRebalanceSettings.settings
                                      .notifyOnFailure,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.autoRebalanceSettings.settings,
                                      "notifyOnFailure",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "autoRebalanceSettings.settings.notifyOnFailure",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("billing.notifyOnFailure")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-checkbox",
                              {
                                on: { change: _vm.onSettingsChange },
                                model: {
                                  value:
                                    _vm.autoRebalanceSettings.settings
                                      .notifyOnDisabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.autoRebalanceSettings.settings,
                                      "notifyOnDisabled",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "autoRebalanceSettings.settings.notifyOnDisabled",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("billing.notifyOnDisabled")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.autoRebalanceSettings.enabled
                    ? _c("div", { staticClass: "setting-row" }, [
                        _c("div", { staticClass: "setting-label" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("billing.emailNotifications"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "setting-description" }, [
                            _vm._v(
                              _vm._s(_vm.$t("billing.emailNotificationsDesc"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "setting-control" },
                          [
                            _c("a-select", {
                              staticStyle: { width: "300px" },
                              attrs: {
                                mode: "tags",
                                placeholder: _vm.$t("billing.emailPlaceholder"),
                                tokenSeparators: [",", ";", " "],
                              },
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value:
                                  _vm.autoRebalanceSettings.settings
                                    .emailRecipients,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings.settings,
                                    "emailRecipients",
                                    $$v
                                  )
                                },
                                expression:
                                  "autoRebalanceSettings.settings.emailRecipients",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "email-hint" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("info"),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("billing.emailHint")) +
                                  "\n                            "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.autoRebalanceSettings.enabled
                    ? _c("div", { staticClass: "auto-rebalance-status-info" }, [
                        _c("div", { staticClass: "status-item" }, [
                          _c("span", { staticClass: "status-label" }, [
                            _vm._v(_vm._s(_vm.$t("billing.lastTrigger"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "status-value" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.autoRebalanceSettings.lastTriggeredAt
                                    ? _vm.formatDate(
                                        _vm.autoRebalanceSettings
                                          .lastTriggeredAt
                                      )
                                    : _vm.$t("billing.neverTriggered")
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.autoRebalanceSettings.failedAttempts > 0
                          ? _c("div", { staticClass: "status-item" }, [
                              _c("span", { staticClass: "status-label" }, [
                                _vm._v(_vm._s(_vm.$t("billing.failedAttempt"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "status-value failure" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.autoRebalanceSettings.failedAttempts
                                      ) +
                                      "/" +
                                      _vm._s(
                                        _vm.autoRebalanceSettings
                                          .maxFailedAttempts
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "setting-actions" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.savingSettings,
                          },
                          on: { click: _vm.saveAutoRebalanceSettings },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("billing.saveSettings")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }